import { useState, useEffect } from 'react';
import IconUp from '../../icons/up';
import IconDown from '../../icons/down';
import IconHideAll from '../../icons/hide-all';
import IconExpandAll from '../../icons/expand-all';
import { BlacklistWarningGroupTypes } from './types';
import BlacklistWarningGroup from './blacklist-warning-group';

import cn from './styles.module.css';

export default function BlacklistWarningGroups({
  hideAll,
  groups,
  currentEmployee,
  resetPaymentOrderTransactionActionIsLoading,
  activePermissions,
  setBlacklistDataItem,
  setBlacklistData,
  applyWarningInProgress,
  onResetTransactionWarningAction,
  applyWarning,
  setBlacklistDataVisible,
  setPanelIsOpen,
  setBlacklistItemVisible,
  resetPaymentOrderTransactionActionIsSuccess,
  selectedWarningId,
  getPaymentOrderWarningsAction,
  paginationInProgress,
  selectedWarningGroup,
  getPaymentOrderWarningById,
  isWarningByIdLoading,
  isWarningByIdFetching,
  showPassed,
  hiddenGroupsIds,
  setHiddenGroupsIds,
  warningsInfo,
  hideApproveActions,
  hideRejectActions,
}: BlacklistWarningGroupTypes) {
  const [collapsed, setCollapsed] = useState(true);
  const [warningsHidden, setWarningsHidden] = useState(false);
  const [hiddenWarningGroupsIds, setHiddenWarningGroupsIds] = useState<
    string[]
  >([]);

  useEffect(() => {
    setWarningsHidden(hideAll);

    let nextHiddenGroups = ([] as string[]).concat(hiddenGroupsIds as string[]);

    if (hideAll) {
      setHiddenWarningGroupsIds(groups?.map((item) => item.id) as string[]);

      groups?.forEach((item) => nextHiddenGroups.push(item.id));
    } else {
      setHiddenWarningGroupsIds([]);

      nextHiddenGroups = nextHiddenGroups?.filter((item) =>
        groups?.every((group) => item !== group.id),
      );
    }

    if (setHiddenGroupsIds) {
      setHiddenGroupsIds(nextHiddenGroups);
    }
  }, [hideAll]);

  useEffect(() => {
    let nextHiddenGroups = ([] as string[]).concat(hiddenGroupsIds as string[]);

    if (!warningsHidden && hiddenWarningGroupsIds?.length === groups?.length) {
      setWarningsHidden(true);

      groups?.forEach((item) => nextHiddenGroups.push(item.id));
    } else if (warningsHidden && hiddenWarningGroupsIds?.length === 0) {
      setWarningsHidden(false);

      nextHiddenGroups = nextHiddenGroups?.filter((item) =>
        groups?.every((group) => item !== group.id),
      );
    }

    if (setHiddenGroupsIds) {
      setHiddenGroupsIds(nextHiddenGroups);
    }
  }, [warningsHidden, hiddenWarningGroupsIds]);

  return (
    <>
      <div className={cn.warningGroupTitle}>
        <button
          type="button"
          className={cn.warningGroupTitleButton}
          onClick={() => setCollapsed(!collapsed)}
        >
          <div className={cn.iconWrapper}>
            {collapsed ? <IconUp /> : <IconDown />}
          </div>
          Block list
        </button>
        <button
          type="button"
          className={cn.warningGroupCollapseButton}
          onClick={() => {
            setWarningsHidden(!warningsHidden);

            let nextHiddenGroups = ([] as string[]).concat(
              hiddenGroupsIds as string[],
            );

            if (!warningsHidden) {
              setHiddenWarningGroupsIds(
                groups?.map((item) => item.id) as string[],
              );

              groups?.forEach((item) => nextHiddenGroups.push(item.id));
            } else {
              setHiddenWarningGroupsIds([]);

              nextHiddenGroups = nextHiddenGroups?.filter((item) =>
                groups?.every((group) => item !== group.id),
              );
            }

            if (setHiddenGroupsIds) {
              setHiddenGroupsIds(nextHiddenGroups);
            }
          }}
        >
          <div className={cn.iconWrapper}>
            {!warningsHidden ? <IconHideAll /> : <IconExpandAll />}
          </div>
          <span>{!warningsHidden ? 'Hide All' : 'Expand All'}</span>
        </button>
      </div>
      {collapsed &&
        groups?.map((item) => (
          <BlacklistWarningGroup
            key={item.id}
            group={item}
            currentEmployee={currentEmployee}
            resetPaymentOrderTransactionActionIsLoading={
              resetPaymentOrderTransactionActionIsLoading
            }
            activePermissions={activePermissions}
            setBlacklistDataItem={setBlacklistDataItem}
            setBlacklistData={setBlacklistData}
            applyWarningInProgress={applyWarningInProgress}
            onResetTransactionWarningAction={onResetTransactionWarningAction}
            applyWarning={applyWarning}
            setBlacklistDataVisible={setBlacklistDataVisible}
            setPanelIsOpen={setPanelIsOpen}
            setBlacklistItemVisible={setBlacklistItemVisible}
            resetPaymentOrderTransactionActionIsSuccess={
              resetPaymentOrderTransactionActionIsSuccess
            }
            selectedWarningId={selectedWarningId}
            getPaymentOrderWarningsAction={getPaymentOrderWarningsAction}
            paginationInProgress={paginationInProgress}
            selectedWarningGroup={selectedWarningGroup}
            getPaymentOrderWarningById={getPaymentOrderWarningById}
            isWarningByIdLoading={isWarningByIdLoading}
            isWarningByIdFetching={isWarningByIdFetching}
            hideAll={hideAll}
            warningsHidden={warningsHidden}
            setHiddenWarningGroupsIds={setHiddenWarningGroupsIds}
            hiddenWarningGroupsIds={hiddenWarningGroupsIds}
            showPassed={showPassed}
            warningsTotal={warningsInfo?.groups[item.id]}
            hideApproveActions={hideApproveActions}
            hideRejectActions={hideRejectActions}
          />
        ))}
    </>
  );
}
